'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = getResource;

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _throttledDispatch = require('./throttled-dispatch');

var _shouldFetch = require('../resource/should-fetch');

var _shouldFetch2 = _interopRequireDefault(_shouldFetch);

var _transformable2 = require('./_transformable');

var _transformable3 = _interopRequireDefault(_transformable2);

var _resource = require('../resource');

var _resource2 = _interopRequireDefault(_resource);

var _getRoot = require('./get-root');

var _getRoot2 = _interopRequireDefault(_getRoot);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resourceDefaults = {
    namespace: null,
    fetch: 'fetch',
    storeName: '$store',
    condition: function condition() {
        return true;
    }
};

function getResource(selector, options) {
    options = (0, _extends3.default)({}, resourceDefaults, options);

    var _options = options,
        storeName = _options.storeName,
        params = _options.params,
        condition = _options.condition,
        _options$placeholder = _options.placeholder,
        placeholder = _options$placeholder === undefined ? null : _options$placeholder;


    var getId = typeof selector === 'function' ? selector : function (cmp) {
        return (0, _get3.default)(cmp, selector);
    };

    var getParams = typeof params === 'function' ? params : function () {
        return params || {};
    };

    var _options2 = options,
        namespace = _options2.namespace;
    var _options3 = options,
        fetch = _options3.fetch;


    if (namespace && typeof fetch === 'string') fetch = namespace + '/' + fetch;

    return (0, _transformable3.default)(function () {
        var id = getId(this);
        var opts = getParams(this);
        var allowFetch = condition(this, opts);
        var store = (0, _get3.default)(this, storeName);
        var dispatch = (0, _throttledDispatch.wrapDispatch)(store.dispatch);

        var root = (0, _getRoot2.default)(store.state, namespace);

        if (allowFetch && (0, _shouldFetch2.default)(root, id)) dispatch(fetch, (0, _extends3.default)({ id: id }, opts));

        var value = (0, _resource2.default)(root, id);

        if (value === null) return placeholder;

        return value;
    });
}